{
  "action": {
    "ok": "OK",
    "cancel": "Annulla",
    "save": "Salva",
    "saved": "Salvato",
    "close": "Chiudi",
    "yes": "Sì",
    "no": "No",
    "delete": "Elimina",
    "remove": "Rimuovi",
    "add": "Aggiungi",
    "edit": "Modifica",
    "rename": "Rinomina",
    "retry": "Riprova",
    "reset": "Ripristina",
    "apply": "Applica",
    "confirm": "Conferma",
    "back": "Indietro",
    "next": "Avanti",
    "done": "Fatto",
    "refresh": "Aggiorna",
    "copy": "Copia",
    "copied": "Copiato",
    "open": "Apri",
    "start": "Avvia",
    "stop": "Ferma",
    "pause": "Sospendi",
    "resume": "Riprendi",
    "continue": "Continua",
    "clear": "Cancella",
    "search": "Cerca",
    "loading": "Caricamento…",
    "saving": "Salvataggio…",
    "searchPlaceholder": "Cerca…",
    "always": "Sempre",
    "deny": "Nega",
    "undo": "Annulla",
    "all": "Tutti"
  },
  "confirm": {
    "title": "Approvazione richiesta: {{tool}}",
    "descriptionEdit": "L'agente vuole modificare un file. Rivedi la richiesta qui sotto e decidi se procedere.",
    "descriptionTool": "L'agente vuole eseguire questo strumento. Rivedi la richiesta qui sotto e decidi se procedere.",
    "fileModification": "Modifica file",
    "toolExecution": "Esecuzione strumento",
    "riskSuffix": "Rischio {{risk}}",
    "command": "Comando",
    "inputLabel": "Input:",
    "trustSuggestionTitle": "Suggerimento pattern attendibile",
    "trustSuggestionHint": "Scegliendo Sempre le chiamate corrispondenti verranno aggiunte all'allowlist per questo progetto.",
    "yoloDestructiveNote": "YOLO è attivo. Questo prompt viene comunque mostrato perché la richiesta è stata classificata come distruttiva.",
    "skipApprovalsTitle": "Salta le approvazioni future",
    "skipApprovalsHint": "Abilita la modalità YOLO e l'agente procede senza chiedere. Le operazioni distruttive richiedono comunque conferma.",
    "enableYoloTitle": "Abilita la modalità YOLO (approva automaticamente questa e le future chiamate non distruttive)",
    "enableYoloBtn": "Abilita YOLO",
    "denyAlways": "Nega sempre",
    "denyAlwaysTitle": "Rifiuta questa e tutte le future chiamate corrispondenti al pattern (d)",
    "noTitle": "Rifiuta questa singola chiamata (Esc / n)",
    "alwaysTitle": "Approva e ricorda il pattern per il progetto (a)",
    "yesTitle": "Approva questa singola chiamata (y)"
  },
  "status": {
    "connected": "Connesso",
    "disconnected": "Disconnesso",
    "connecting": "Connessione…",
    "reconnecting": "Riconnessione…",
    "ready": "Pronto",
    "error": "Errore",
    "offline": "Offline",
    "online": "Online",
    "live": "Live",
    "budgetWarning": "avviso budget",
    "running": "In corso",
    "inProgress": "In corso",
    "working": "lavora"
  },
  "time": {
    "justNow": "adesso",
    "secondsAgo_one": "{{count}} secondo fa",
    "secondsAgo_other": "{{count}} secondi fa",
    "minutesAgo_one": "{{count}} minuto fa",
    "minutesAgo_other": "{{count}} minuti fa",
    "hoursAgo_one": "{{count}} ora fa",
    "hoursAgo_other": "{{count}} ore fa",
    "daysAgo_one": "{{count}} giorno fa",
    "daysAgo_other": "{{count}} giorni fa",
    "compactSecondsAgo": "{{count}} s fa",
    "compactMinutesAgo": "{{count}} min fa",
    "compactHoursAgo": "{{count}} h fa"
  },
  "error": {
    "title": "Qualcosa è andato storto",
    "body": "Si è verificato un errore di rendering. La tua sessione è ancora attiva sul server — ricaricare riprenderà da dove eri rimasto.",
    "reload": "Ricarica pagina",
    "tryAgain": "Riprova"
  },
  "sparkline": {
    "noActivity": "Nessuna attività",
    "noActivityYet": "Nessuna attività ancora",
    "activityMax": "Sparkline attività: max {{count}} eventi",
    "activityPeak": "Sparkline attività — picco {{count}} eventi/intervallo"
  }
}
